export default __webpack_public_path__ + "static/media/night.79f51477.jpg";